import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";

export const get = (companyId: any, membMpiNo: any, dos: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_ENCOUNTER_REQUEST });

  const payload = {
    "CompanyId": companyId,
    "MembMpiNo": membMpiNo,
    "DateOfService": dos
  }

  return api.eligibility.encounter.get(payload)
    .then((res: any) => {

      dispatch({
        type: types.GET_ENCOUNTER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_ENCOUNTER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const save = (details: any, memberInfo: any, dos: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.eligibilityEncounter.isSaving) { return Promise.reject(); }

  dispatch({ type: types.SAVE_ENCOUNTER_REQUEST });

  details.RmiCompanyId = memberInfo.RmiCompanyId;
  details.RmiMembMpiNo = memberInfo.RmiMembMpiNo;
  details.RmiProvKeyId = memberInfo.RmiProvKeyId;
  details.RmiDateOfService = dos;
  details.RmiHeightInches = details.hasOwnProperty("RmiHeightInchesVitals") ? Number(details.RmiHeightInchesVitals) : null;
  details.RmiWeightLbs = details.hasOwnProperty("RmiWeightLbsVitals") ? Number(details.RmiWeightLbsVitals) : null;
  details.RmiBMI = details.hasOwnProperty("RmiBMIVitals") ? Number(details.RmiBMIVitals) : null;
  details.RmiExerciseMinPerDay = details.hasOwnProperty("RmiExerciseMinPerDay") ? Number(details.RmiExerciseMinPerDay) : null;
  details.RmiExerciseDaysPerWeek = details.hasOwnProperty("RmiExerciseDaysPerWeek") ? Number(details.RmiExerciseDaysPerWeek) : null;
  details.RmiSystolic = details.hasOwnProperty("RmiSystolicVitals") ? Number(details.RmiSystolicVitals) : null
  details.RmiDiastolic = details.hasOwnProperty("RmiDiastolicVitals") ? Number(details.RmiDiastolicVitals) : null;
  details.RmiFalls12Mo = details.hasOwnProperty("RmiFalls12Mo") ? Number(details.RmiFalls12Mo) : null;
  details.RmiPainLevel = details.hasOwnProperty("RmiPainLevel") ? Number(details.RmiPainLevel) : null;
  details.RmiDepression = details.RmiDepression ? details.RmiDepression : null;
  details.RmiPapsmearOutcome = details.RmiPapsmearOutcome ? details.RmiPapsmearOutcome : null;
  details.RmiFunctionalRiskLevel = details.hasOwnProperty("RmiFunctionalRiskLevel") ? Number(details.RmiFunctionalRiskLevel) : null;

  return api.eligibility.encounter.save(details)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_ENCOUNTER_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_ENCOUNTER_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

